import { Col, Row } from "reactstrap"
import { SaveButton } from "./Buttons"
import ModalComponent from "./Modals"

const UnsavedAlertModal = ({ isOpen, onClose, onSave }) => {
  return (
    <ModalComponent open={isOpen} onClose={onClose}>
      <Row>
        <h5>There are unsaved changes. Do you want to save before leaving?</h5>
      </Row>
      <Row className="mt-3">
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Don't Save"
            onClick={onClose}
          />
        </Col>
        <Col>
          <SaveButton
            type="button"
            content="Save"
            fullWidth={true}
            onClick={onSave}
          />
        </Col>
      </Row>
    </ModalComponent>
  )
}

export default UnsavedAlertModal
